import script from "./DictionaryItemModify.vue?vue&type=script&setup=true&lang=js"
export * from "./DictionaryItemModify.vue?vue&type=script&setup=true&lang=js"

import "./DictionaryItemModify.vue?vue&type=style&index=0&id=199504f6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-199504f6"]])

export default __exports__